import { cn } from '../lib/cn';

type Tone = 'neutral' | 'info' | 'positive' | 'warning' | 'negative' | 'accent';

const TONES: Record<Tone, string> = {
  neutral: 'bg-paper-2 text-ink-3 border border-rule',
  info: 'bg-info-soft text-info border border-info/20',
  positive: 'bg-positive-soft text-positive border border-positive/20',
  warning: 'bg-warning-soft text-warning border border-warning/20',
  negative: 'bg-negative-soft text-negative border border-negative/20',
  accent: 'bg-accent-soft text-accent border border-accent/20',
};

export function StatusPill({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone;
  children: React.ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium uppercase tracking-wide whitespace-nowrap',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

export function orderStatusTone(status: string): Tone {
  switch (status) {
    case 'DRAFT':
      return 'neutral';
    case 'CONFIRMED':
      return 'info';
    case 'READY':
      return 'accent';
    case 'DELIVERED':
      return 'positive';
    case 'COMPLETED':
      return 'positive';
    case 'CANCELLED':
      return 'negative';
    default:
      return 'neutral';
  }
}

export function paymentStatusTone(status: string): Tone {
  switch (status) {
    case 'paid':
      return 'positive';
    case 'partial':
      return 'warning';
    case 'unpaid':
      return 'neutral';
    case 'refunded':
      return 'negative';
    default:
      return 'neutral';
  }
}
